module.exports = __webpack_public_path__ + "static/img/01.8cc091a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ware-2018/01.png
// module id = /l19
// module chunks = 0